import gql from 'graphql-tag';
import { mutation } from 'services/graphql';

export const updateSurfaceMutation = gql`
  mutation updateSurface($input: UpdateSurfaceInput!) {
    updateSurface(input: $input) {
      data {
        id
        name
      }
      error
      success
    }
  }
`;

export default mutation(updateSurfaceMutation);
